import { subscribeChannel, publishChannel } from './channelUtils';

export function sendDate(date) {
    
    publishChannel('date-upsert', date);

}

export function listenDate(callback) {

    return subscribeChannel((event) => {

        const { tipo, payload } = event.data;

        if (tipo !== 'date-upsert') {
            return;
        }

        callback({ tipo, payload });

    });

}